import React from 'react'
import { Container } from '@material-ui/core'
import styles from './header_.module.css'
import getStringsBasedLang from '../../strings/get_strings'
import HeaderMobile from './header_mobile'
import BtnLogout from './btn_logout';
import BtnLogin from './btn_login';
import BtnSelectLang from './btn_select_lang';
import { useNavigate, useLocation } from "react-router-dom";
import { createData } from '../../api/http-service'
import UseErrorHandling from '../../hook/UseErrorHandling'

export default function NewHeader() {

    const location = useLocation()
    const pathname = location.pathname
    let navigate = useNavigate()
    const info = JSON.parse(localStorage.getItem("info"))
    let token = localStorage.getItem('token')
    const lang = localStorage.getItem("lang")
    const handleErrorApi = UseErrorHandling();

    const logoutHandler = () => {
        createData("user/logout", {
            token: token,
          })
            .then((logoutResult) => {
              if (!logoutResult?.success) {
                handleErrorApi(logoutResult);
                return;
              }
              
            })
            .catch((error) => {
              if (error?.response) {
                handleErrorApi(error?.response.data);
              }
            });
        localStorage.removeItem("token")
        localStorage.removeItem("info")
        navigate('/login')
    }

    const hoverHandler = (route) => {
        if (route === pathname.replace("/", ""))
            return styles.menu_style_selected
    }

    const logoHandler = () => {
        return <img className={styles.img} onClick={() => navigate('/')} src={require(`../../assets/icons/${pathname === "/" ? 'main_logo' : "logo_main_other"}.svg`)} alt="Icon" />
    }

    return (
        <div className={styles.container}>
            <Container>
                <div className={`grid grid-cols-6 items-center ${styles.child_container} xs:hidden sm:hidden md:hidden`}>
                    <div className={`${styles.img_container} col-span-1 `}>{logoHandler()}</div>
                    <div className={`${styles.menu} ${!lang || (lang === 'en') ? '!justify-end mr-5' : 'mr-16'} col-span-3`}>
                        <div className={`mb-1 ${(!lang || (lang === 'en') ? 'w-5' : '')} ${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : styles.menu_style_other}`} onClick={() => navigate('/')}><img className={styles.home_icon} src={require(`../../assets/icons/${pathname === '/' ? 'home-fill' : 'home-fill-blue'}.svg`)} alt="Icon" /></div>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : `${styles.menu_style_other} ${hoverHandler('search')} ${hoverHandler('search/[packagename]')}`}`} onClick={() => navigate('/search')}>{getStringsBasedLang("general_search")}</span>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : `${styles.menu_style_other} ${hoverHandler('aboutApp')}`}`} onClick={() => navigate('/aboutApp')}>{getStringsBasedLang("footer_aboutSystem")}</span>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : styles.menu_style_other}`} onClick={() => window.open(`${(!lang || lang === 'en' ? 'https://supporten.cyberno.ir/en/blog/multiscanner-intro' : 'https://support.cyberno.ir/fa/blog/multiscanner-intro')}`)}>{getStringsBasedLang("general_faq")}</span>
                        <span className={`${styles.menu_style} ${pathname === "/" ? styles.menu_style_home : styles.menu_style_other}`} onClick={() => window.open(`${(!lang || lang === 'en' ? 'https://supporten.cyberno.ir/en/customer/create-ticket/' : 'https://support.cyberno.ir/fa/customer/create-ticket/')}`)}>{getStringsBasedLang("footer_contactUs")}</span>
                    </div>
                    <div className={`${styles.btn_container} col-span-2 flex  lg:flex-col items-center justify-center`}>
                        <BtnSelectLang />
                        {
                            info && info.user_level !== 'guest' ?
                                <div>
                                    <button onClick={() => navigate('/changePassword')} className='w-32 primary_text_color ml-2 rounded-2xl border-0 bg-white py-2 cursor-pointer'>{getStringsBasedLang("general_changePass")}</button>
                                    <BtnLogout logoutHandler={() => logoutHandler()} />
                                </div>
                                :
                                <BtnLogin onClickHandler={() => navigate('/login')} />
                        }
                    </div>
                </div>
                <div className='hidden xs:block sm:block md:block'><HeaderMobile info={info} logout={() => logoutHandler()} /></div>
            </Container>
        </div>
    )
}


